<template>
  <div class="main">
    <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
      <el-tab-pane label="动作列表" name="first">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div class="search-content">
              <el-select v-model="queryData.actionType" placeholder="动作分类">
                <el-option label="动作分类" value="0"></el-option>
                <el-option
                  v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-select v-model="queryData.bodyType" placeholder="部位分类">
                <el-option label="部位分类" value=""></el-option>
                <el-option
                  v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
              <el-input v-model="queryData.actionName"  placeholder="动作名称"></el-input>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
              <el-button type="primary" @click="clickdialogAdd">新增</el-button>
              <el-button type="success" @click="clickBatchAdd">批量新增</el-button>
              <UploadExcel @change="changeUploadExcel"></UploadExcel>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <div class="table-container">
            <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
              <el-table-column prop="id" label="序号" width="80" fixed="left" sortable="custom"></el-table-column>
              <el-table-column prop="calculateTypeUi" label="计算类型" width="120" sortable="custom"></el-table-column>
              <el-table-column prop="actionTypeUi" label="动作分类" width="150" sortable="custom"></el-table-column>
              <el-table-column prop="bodyTypeUi" label="部位分类" width="120" sortable="custom"></el-table-column>
              <el-table-column prop="actionName" label="动作名称" width="180" sortable="custom"></el-table-column>
              <el-table-column prop="" label="列表封面" width="100">
                <template v-slot="scope">
                  <el-image
                    v-if="scope.row.actionIconUi"
                    style="width: 48px; height: 48px"
                    :src="scope.row.actionIconUi"
                    :preview-src-list="[scope.row.actionIconUi]"
                    fit="cover">
                  </el-image>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="" label="详情页封面" width="110">
                <template v-slot="scope">
                  <el-image
                    v-if="scope.row.actionIconDetailsUi"
                    style="width: 48px; height: 48px"
                    :src="scope.row.actionIconDetailsUi"
                    :preview-src-list="[scope.row.actionIconDetailsUi]"
                    fit="cover">
                  </el-image>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="actionTime" label="动作时长" width="100" sortable="custom">
                <template slot-scope="props">
                  {{props.row.actionTime}}秒
                </template>
              </el-table-column>
              <el-table-column prop="" label="动作视频" width="100">
                <template v-slot="scope">
                  <el-link v-if="scope.row.actionVideoUrlUi" :href="scope.row.actionVideoUrlUi" target="_blank" type="primary">视频</el-link>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180" sortable="custom"></el-table-column>
              <el-table-column label="英文名称" min-width="120">
                <template slot-scope="scope">
                  <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['action_name']) || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="德文名称" min-width="120">
                <template slot-scope="scope">
                  <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['action_name']) || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Operation" label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickdialogEdit(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                    <el-link :underline="false" type="danger" icon="el-icon-delete" class="mr12" @click="ClickDelete(scope.row)"></el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->
      </el-tab-pane>
    </el-tabs>
    <!---------------------- 以下是弹框内容 ---------------------->
    <!-- 新增动作 -->
    <el-dialog title="添加动作" :visible.sync="dialogAdd" width="35%" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="addData" label-width="150px">
          <el-form-item label="动作分类" :required=true>
            <el-select v-model="addData.actionType" multiple placeholder="动作分类">
              <el-option
                v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部位分类" :required=true>
            <el-select v-model="addData.bodyType" multiple placeholder="部位分类">
              <el-option
                v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计算类型" :required=true>
            <el-select v-model="addData.calculateType" placeholder="计算类型">
              <el-option label="计次" value="1"></el-option>
              <el-option label="计时" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡路里" v-if="addData.calculateType == 2">
            <el-input v-model="addData.kaluli" placeholder="请输入卡路里">
              <template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">Kcal(千卡)</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="杠铃模式" v-if="addData.calculateType == 1">
            <el-select v-model="addData.gangling" placeholder="杠铃模式">
              <el-option label="杠铃" value="杠铃"></el-option>
              <el-option label="非杠铃" value="非杠铃"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="动作名称" :required=true>
            <el-input v-model="addData.actionName" placeholder="请输入动作名称"></el-input>
          </el-form-item>
          <el-form-item label="列表封面" :required=true>
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleAddIconUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="addData.actionIconUi || addData.actionIcon" :src="addData.actionIconUi || getImageUrl(addData.actionIcon)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
          <el-form-item label="详情页封面" :required=true>
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleAddIconDetailsUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="addData.actionIconDetailsUi || addData.actionIconDetails" :src="addData.actionIconDetailsUi || getImageUrl(addData.actionIconDetails)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
          <el-form-item label="动作时长" :required=true>
            <el-input v-model="addData.actionTime" placeholder="请输入动作时长">
              <template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">秒</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="动作视频链接" :required=true>
            <el-upload
              class="video-uploader"
              :action="''"
              :http-request="handleAddVideoUpload"
              :show-file-list="false"
              :before-upload="beforeVideoUpload"
              :auto-upload="true">
              <el-button size="small" type="primary" v-if="!addData.actionVideoUrlUi && !addData.actionVideoUrl">上传视频</el-button>
              <div v-else>
                <el-button size="small" type="success">已上传</el-button>
                <el-button size="small" type="text" @click.stop="previewVideo(addData.actionVideoUrlUi || addData.actionVideoUrl)">预览</el-button>
              </div>
            </el-upload>
            <div class="upload-tip">支持mp4、avi格式，大小不超过50MB</div>
          </el-form-item>
          <el-form-item label="动作要领" :required=true>
            <el-input type="textarea" v-model="addData.actionExecutionPoint" placeholder="请输入动作要领"></el-input>
          </el-form-item>
          <el-form-item label="呼吸方法" :required=true>
            <el-input type="textarea" v-model="addData.actionRespiratoryRate" placeholder="请输入呼吸方法"></el-input>
          </el-form-item>
          <el-form-item label="动作感觉" :required=true>
            <el-input type="textarea" v-model="addData.actionSense" placeholder="请输入动作感觉"></el-input>
          </el-form-item>
          <el-form-item label="易犯错误" :required=true>
            <el-input type="textarea" v-model="addData.actionErrorCorrection" placeholder="请输入易犯错误"></el-input>
          </el-form-item>
          <el-form-item label="训练肌群" :required=true>
            <el-select v-model="addData.actionMuscleRoup" multiple placeholder="训练肌群">
              <el-option
                v-for="item in aptustwoGvListMuscleRoup" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所需配件" :required=true>
            <el-select v-model="addData.actionAccessories" multiple placeholder="所需配件">
              <el-option
                v-for="item in aptustwoGvListAccessories" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用位置" :required=true>
            <el-select v-model="addData.actionLineBegin" multiple placeholder="使用位置">
              <el-option
                v-for="item in aptustwoGvListUseLocation" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ActionDatabaseInsert()" >确 认</el-button>
        <el-button @click="dialogAdd = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 新增动作 End -->

    <!-- 编辑动作 -->
    <el-dialog title="编辑动作" :visible.sync="dialogEdit" width="35%" class="newAdd" :close-on-click-modal="false" v-loading="uploadLoading">
      <div class="addUser_body">
        <el-form ref="userMsg" :model="editData" label-width="150px">
          <el-form-item label="动作分类" :required=true>
            <el-select v-model="editData.actionType" multiple placeholder="动作分类">
              <el-option
                v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部位分类" :required=true>
            <el-select v-model="editData.bodyType" multiple placeholder="部位分类">
              <el-option
                v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计算类型" :required=true>
            <el-select v-model="editData.calculateType" placeholder="计算类型">
              <el-option label="计次" value="1"></el-option>
              <el-option label="计时" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="卡路里" v-if="editData.calculateType == 2">
            <el-input v-model="editData.kaluli" placeholder="请输入卡路里">
              <template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">Kcal(千卡)</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="杠铃模式" v-if="editData.calculateType == 1">
            <el-select v-model="editData.gangling" placeholder="杠铃模式">
              <el-option label="杠铃" value="杠铃"></el-option>
              <el-option label="非杠铃" value="非杠铃"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="动作名称" :required=true>
            <el-input v-model="editData.actionName" placeholder="请输入动作名称"></el-input>
          </el-form-item>
          <el-form-item label="列表封面" :required=true>
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleEditIconUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="editData.actionIconUi || editData.actionIcon" :src="editData.actionIconUi || getImageUrl(editData.actionIcon)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
          <el-form-item label="详情页封面" :required=true>
            <el-upload
              class="cover-uploader"
              :action="''"
              :http-request="handleEditIconDetailsUpload"
              :show-file-list="false"
              :before-upload="beforeImageUpload"
              :auto-upload="true">
              <img v-if="editData.actionIconDetailsUi || editData.actionIconDetails" :src="editData.actionIconDetailsUi || getImageUrl(editData.actionIconDetails)" class="cover-image">
              <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
          </el-form-item>
          <el-form-item label="动作时长" :required=true>
            <el-input v-model="editData.actionTime" placeholder="请输入动作时长">
              <template slot="append">
                <span style="width: 100px; display: inline-block;text-align: center;">秒</span>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="动作视频链接" :required=true>
            <el-upload
              class="video-uploader"
              :action="''"
              :http-request="handleEditVideoUpload"
              :show-file-list="false"
              :before-upload="beforeVideoUpload"
              :auto-upload="true">
              <el-button size="small" type="primary" v-if="!editData.actionVideoUrlUi && !editData.actionVideoUrl">上传视频</el-button>
              <div v-else>
                <el-button size="small" type="success">已上传</el-button>
                <el-button size="small" type="text" @click.stop="previewVideo(editData.actionVideoUrlUi || editData.actionVideoUrl)">预览</el-button>
              </div>
            </el-upload>
            <div class="upload-tip">支持mp4、avi格式，大小不超过50MB</div>
          </el-form-item>
          <el-form-item label="动作要领" :required=true>
            <el-input type="textarea" v-model="editData.actionExecutionPoint" placeholder="请输入动作要领"></el-input>
          </el-form-item>
          <el-form-item label="呼吸方法" :required=true>
            <el-input type="textarea" v-model="editData.actionRespiratoryRate" placeholder="请输入呼吸方法"></el-input>
          </el-form-item>
          <el-form-item label="动作感觉" :required=true>
            <el-input type="textarea" v-model="editData.actionSense" placeholder="请输入动作感觉"></el-input>
          </el-form-item>
          <el-form-item label="易犯错误" :required=true>
            <el-input type="textarea" v-model="editData.actionErrorCorrection" placeholder="请输入易犯错误"></el-input>
          </el-form-item>
          <el-form-item label="训练肌群" :required=true>
            <el-select v-model="editData.actionMuscleRoup" multiple placeholder="训练肌群">
              <el-option
                v-for="item in aptustwoGvListMuscleRoup" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所需配件" :required=true>
            <el-select v-model="editData.actionAccessories" multiple placeholder="所需配件">
              <el-option
                v-for="item in aptustwoGvListAccessories" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用位置" :required=true>
            <el-select v-model="editData.actionLineBegin" multiple placeholder="使用位置">
              <el-option
                v-for="item in aptustwoGvListUseLocation" :key="item.gv" :label="item.name" :value="item.gv">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ActionDatabaseUpdate()" >确 认</el-button>
        <el-button @click="dialogEdit = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑动作 End -->

    <!-- 删除 -->
    <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel" :close-on-click-modal="false">
      <div class="confirmMsg">确定删除？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ActionDatabaseDelete" >确 定</el-button>
        <el-button @click="dialogDel = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 删除 End -->

    <!-- 批量新增弹窗 -->
    <el-dialog title="批量新增动作" :visible.sync="dialogBatchAdd" fullscreen class="batch-dialog" :close-on-click-modal="false">
      <div class="batch-add-container">
        <div class="batch-toolbar">
          <el-button type="primary" @click="addBatchRow" icon="el-icon-plus">添加一行</el-button>
          <el-button type="warning" @click="clearBatchData" icon="el-icon-delete">清空</el-button>
          <span class="batch-tip">提示：表格支持直接编辑，必填字段不能为空</span>
        </div>
        
        <el-table :data="batchData" border stripe class="batch-table" height="calc(100vh - 220px)">
          <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
          
          <el-table-column label="动作分类" width="150">
            <template slot="header">
              <span class="required-field">动作分类</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.actionType" multiple placeholder="选择" size="small" style="width: 100%">
                <el-option v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="部位分类" width="150">
            <template slot="header">
              <span class="required-field">部位分类</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.bodyType" multiple placeholder="选择" size="small" style="width: 100%">
                <el-option v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="计算类型" width="120">
            <template slot="header">
              <span class="required-field">计算类型</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.calculateType" placeholder="选择" size="small" style="width: 100%">
                <el-option label="计次" value="1"></el-option>
                <el-option label="计时" value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="卡路里" width="120">
            <template slot-scope="scope">
              <el-input v-model="scope.row.kaluli" placeholder="请输入" size="small" v-if="scope.row.calculateType == '2'"></el-input>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column label="杠铃模式" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.gangling" placeholder="选择" size="small" style="width: 100%" v-if="scope.row.calculateType == '1'">
                <el-option label="杠铃" value="杠铃"></el-option>
                <el-option label="非杠铃" value="非杠铃"></el-option>
              </el-select>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column label="动作名称" width="150">
            <template slot="header">
              <span class="required-field">动作名称</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionName" placeholder="必填" size="small"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="列表封面" width="180">
            <template slot="header">
              <span class="required-field">列表封面</span>
            </template>
            <template slot-scope="scope">
              <el-upload
                class="batch-uploader"
                :action="''"
                :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'actionIcon')"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true">
                <img v-if="scope.row.actionIconUi || scope.row.actionIcon" :src="scope.row.actionIconUi || getImageUrl(scope.row.actionIcon)" class="batch-preview-image">
                <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
              </el-upload>
            </template>
          </el-table-column>

          <el-table-column label="详情页封面" width="180">
            <template slot="header">
              <span class="required-field">详情页封面</span>
            </template>
            <template slot-scope="scope">
              <el-upload
                class="batch-uploader"
                :action="''"
                :http-request="(options) => handleBatchIconUpload(options, scope.$index, 'actionIconDetails')"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true">
                <img v-if="scope.row.actionIconDetailsUi || scope.row.actionIconDetails" :src="scope.row.actionIconDetailsUi || getImageUrl(scope.row.actionIconDetails)" class="batch-preview-image">
                <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传</el-button>
              </el-upload>
            </template>
          </el-table-column>

          <el-table-column label="动作时长(秒)" width="110">
            <template slot="header">
              <span class="required-field">动作时长(秒)</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionTime" placeholder="秒" size="small" type="number"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="动作视频" width="180">
            <template slot="header">
              <span class="required-field">动作视频</span>
            </template>
            <template slot-scope="scope">
              <el-upload
                class="batch-uploader"
                :action="''"
                :http-request="(options) => handleBatchVideoUpload(options, scope.$index)"
                :show-file-list="false"
                :before-upload="beforeVideoUpload"
                :auto-upload="true">
                <div v-if="scope.row.actionVideoUrlUi || scope.row.actionVideoUrl">
                  <el-button size="mini" type="success" icon="el-icon-video-camera">已上传</el-button>
                  <el-button size="mini" type="text" @click.stop="previewVideo(scope.row.actionVideoUrlUi || scope.row.actionVideoUrl)">预览</el-button>
                </div>
                <el-button v-else size="mini" type="primary" icon="el-icon-upload">上传视频</el-button>
              </el-upload>
            </template>
          </el-table-column>

          <el-table-column label="动作要领" width="150">
            <template slot="header">
              <span class="required-field">动作要领</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionExecutionPoint" placeholder="动作要领" size="small" type="textarea" :rows="2"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="呼吸方法" width="150">
            <template slot="header">
              <span class="required-field">呼吸方法</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionRespiratoryRate" placeholder="呼吸方法" size="small" type="textarea" :rows="2"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="动作感觉" width="150">
            <template slot="header">
              <span class="required-field">动作感觉</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionSense" placeholder="动作感觉" size="small" type="textarea" :rows="2"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="易犯错误" width="150">
            <template slot="header">
              <span class="required-field">易犯错误</span>
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.actionErrorCorrection" placeholder="易犯错误" size="small" type="textarea" :rows="2"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="训练肌群" width="150">
            <template slot="header">
              <span class="required-field">训练肌群</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.actionMuscleRoup" multiple placeholder="选择" size="small" style="width: 100%">
                <el-option v-for="item in aptustwoGvListMuscleRoup" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="所需配件" width="150">
            <template slot="header">
              <span class="required-field">所需配件</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.actionAccessories" multiple placeholder="选择" size="small" style="width: 100%">
                <el-option v-for="item in aptustwoGvListAccessories" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="使用位置" width="150">
            <template slot="header">
              <span class="required-field">使用位置</span>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.actionLineBegin" multiple placeholder="选择" size="small" style="width: 100%">
                <el-option v-for="item in aptustwoGvListUseLocation" :key="item.gv" :label="item.name" :value="item.gv"></el-option>
              </el-select>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="80" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deleteBatchRow(scope.$index)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="saveBatchData" :loading="batchLoading" icon="el-icon-check">保存全部</el-button>
        <el-button @click="dialogBatchAdd = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 批量新增弹窗 End -->

    <!-- 翻译管理 -->
    <i18n-translation-dialog
      :visible.sync="dialogI18n"
      :entity-type="i18nEntityType"
      :entity-id="i18nEntityId"
      :fields="i18nFields">
    </i18n-translation-dialog>
    <!-- 翻译管理 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import UploadExcel from '../components/UploadExcel.vue'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: { UploadExcel, I18nTranslationDialog },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      aptustwoGvListActionType:[],
      aptustwoGvListBodyType:[],
      aptustwoGvListMuscleRoup:[],
      aptustwoGvListAccessories:[],
      aptustwoGvListUseLocation:[],
      queryData: {
        actionType: '0',
        bodyType: '',
        actionName: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        calculateType: '',
        kaluli: '0',
        gangling: '非杠铃',
        actionType: [],
        bodyType: [],
        actionName: '',
        actionIcon: '',
        actionIconUi: '',
        actionIconDetails: '',
        actionIconDetailsUi: '',
        actionTime: '',
        actionVideoUrl: '',
        actionVideoUrlUi: '',
        actionExecutionPoint: '',
        actionRespiratoryRate: '',
        actionSense: '',
        actionErrorCorrection: '',
        actionMuscleRoup: [],
        actionAccessories: [],
        actionLineBegin: []
      },
      uploadAction: Vue.prototype.global.Url_Base + 'Upload/file',
      uploadLoading: false,
      // 编辑
      dialogEdit: false,
      editData: {
        id: '',
        calculateType: '',
        kaluli: '0',
        gangling: '非杠铃',
        actionType: [],
        bodyType: [],
        actionName: '',
        actionIcon: '',
        actionIconUi: '',
        actionIconDetails: '',
        actionIconDetailsUi: '',
        actionTime: '',
        actionVideoUrl: '',
        actionVideoUrlUi: '',
        actionExecutionPoint: '',
        actionRespiratoryRate: '',
        actionSense: '',
        actionErrorCorrection: '',
        actionMuscleRoup: [],
        actionAccessories: [],
        actionLineBegin: []
      },
      // 删除
      deleteForm: {
        id: ''
      },
      dialogDel: false,
      // 批量新增
      dialogBatchAdd: false,
      batchData: [],
      batchLoading: false,
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'ACTION',
      i18nFields: [
        { name: 'action_name', label: '动作名称', type: 'input' },
        { name: 'action_execution_point', label: '动作要领', type: 'textarea' },
        { name: 'action_respiratory_rate', label: '呼吸方法', type: 'textarea' },
        { name: 'action_sense', label: '动作感觉', type: 'textarea' },
        { name: 'action_error_correction', label: '易犯错误', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  watch: {
    dialogI18n(val) {
      if (!val) {
        this.loadTranslations('ACTION', this.dataList, 'id')
      }
    }
  },
  mounted () {
    this.aptustwoGvListActionType = JSON.parse(localStorage.getItem('aptustwoGvListActionType'));
    this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'));
    this.aptustwoGvListMuscleRoup = JSON.parse(localStorage.getItem('aptustwoGvListMuscleRoup'));
    this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'));
    this.aptustwoGvListUseLocation = JSON.parse(localStorage.getItem('aptustwoGvListUseLocation'));
    this.ActionDatabaseList()
    this.ActionDatabaseNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleSortChange ({ prop, order }) {
      const fieldMap = {
        'calculateTypeUi': 'calculateType',
        'actionTypeUi': 'actionType',
        'bodyTypeUi': 'bodyType'
      }
      this.sortField = fieldMap[prop] || prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickQuery () {
      this.page_no = 1
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickQueryReset () {
      this.queryData.actionType = '0'
      this.queryData.bodyType = ''
      this.queryData.actionName = ''
      this.clickQuery()
    },
    clickdialogAdd () {
      this.dialogAdd = true
      this.addData.kaluli = '0'
      this.addData.gangling = '非杠铃'
      this.addData.actionType = []
      this.addData.bodyType = []
      this.addData.actionName = ''
      this.addData.actionIcon = ''
      this.addData.actionIconDetails = ''
      this.addData.actionTime = ''
      this.addData.actionVideoUrl = ''
      this.addData.actionExecutionPoint = ''
      this.addData.actionRespiratoryRate = ''
      this.addData.actionSense = ''
      this.addData.actionErrorCorrection = ''
      this.addData.actionMuscleRoup = []
      this.addData.actionAccessories = []
      this.addData.actionLineBegin = []
    },
    clickdialogEdit (row) {
      this.dialogEdit = true
      this.editData.id = row.id
      this.editData.calculateType = row.calculateType.toString()
      this.editData.kaluli = row.kaluli
      this.editData.gangling = row.gangling
      this.editData.actionType = Vue.prototype.ConvertStringToArray(row.actionType)
      this.editData.bodyType = Vue.prototype.ConvertStringToArray(row.bodyType)
      this.editData.actionName = row.actionName
      this.editData.actionIcon = row.actionIcon
      this.editData.actionIconUi = row.actionIconUi
      this.editData.actionIconDetails = row.actionIconDetails
      this.editData.actionIconDetailsUi = row.actionIconDetailsUi
      this.editData.actionTime = row.actionTime
      this.editData.actionVideoUrl = row.actionVideoUrl
      this.editData.actionVideoUrlUi = row.actionVideoUrlUi
      this.editData.actionExecutionPoint = row.actionExecutionPoint
      this.editData.actionRespiratoryRate = row.actionRespiratoryRate
      this.editData.actionSense = row.actionSense
      this.editData.actionErrorCorrection = row.actionErrorCorrection
      this.editData.actionMuscleRoup = Vue.prototype.ConvertStringToArray(row.actionMuscleRoup)
      this.editData.actionAccessories = Vue.prototype.ConvertStringToArray(row.actionAccessories)
      this.editData.actionLineBegin = Vue.prototype.ConvertStringToArray(row.actionLineBegin)
    },
    ClickDelete (row) {
      this.dialogDel = true
      this.deleteForm.id = row.id
    },
    changeUploadExcel (response) {
      console.log(response)
      Vue.prototype.FunRemindOnlyError(response)
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data)
        this.ActionDatabaseList()
        this.ActionDatabaseNum()
      }
    },
    ActionDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('ACTION', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    ActionDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ActionDatabaseInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = Vue.prototype.ConvertArrayToString(that.addData.actionType)
      data.bodyType = Vue.prototype.ConvertArrayToString(that.addData.bodyType)
      data.actionName = that.addData.actionName
      data.actionIcon = that.addData.actionIcon
      data.actionIconDetails = that.addData.actionIconDetails
      data.actionTime = that.addData.actionTime
      data.actionVideoUrl = that.addData.actionVideoUrl
      data.actionExecutionPoint = that.addData.actionExecutionPoint
      data.actionRespiratoryRate = that.addData.actionRespiratoryRate
      data.actionSense = that.addData.actionSense
      data.actionErrorCorrection = that.addData.actionErrorCorrection
      data.actionMuscleRoup = Vue.prototype.ConvertArrayToString(that.addData.actionMuscleRoup)
      data.actionAccessories = Vue.prototype.ConvertArrayToString(that.addData.actionAccessories)
      data.actionLineBegin = Vue.prototype.ConvertArrayToString(that.addData.actionLineBegin)
      data.calculateType = that.addData.calculateType
      data.kaluli = that.addData.kaluli
      data.gangling = that.addData.gangling
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.ActionDatabaseList()
            that.ActionDatabaseNum()
            that.dialogAdd = false
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAdd = false
        })
    },
    ActionDatabaseUpdate: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editData.id
      data.actionType = Vue.prototype.ConvertArrayToString(that.editData.actionType)
      data.bodyType = Vue.prototype.ConvertArrayToString(that.editData.bodyType)
      data.actionName = that.editData.actionName
      data.actionIcon = that.editData.actionIcon
      data.actionIconDetails = that.editData.actionIconDetails
      data.actionTime = that.editData.actionTime
      data.actionVideoUrl = that.editData.actionVideoUrl
      data.actionExecutionPoint = that.editData.actionExecutionPoint
      data.actionRespiratoryRate = that.editData.actionRespiratoryRate
      data.actionSense = that.editData.actionSense
      data.actionErrorCorrection = that.editData.actionErrorCorrection
      data.actionMuscleRoup = Vue.prototype.ConvertArrayToString(that.editData.actionMuscleRoup)
      data.actionAccessories = Vue.prototype.ConvertArrayToString(that.editData.actionAccessories)
      data.actionLineBegin = Vue.prototype.ConvertArrayToString(that.editData.actionLineBegin)
      data.calculateType = that.editData.calculateType
      data.kaluli = that.editData.kaluli
      data.gangling = that.editData.gangling
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseUpdate, Qs.stringify(data))
        .then(function (response) {
          that.dialogEdit = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.ActionDatabaseList()
            that.ActionDatabaseNum()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEdit = false
        })
    },
    ActionDatabaseDelete: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.deleteForm.id
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseDelete, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.ActionDatabaseList()
            that.ActionDatabaseNum()
          }
          that.dialogDel = false
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    // 图片上传前校验
    beforeImageUpload (file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isImage) {
        this.$message.error('上传图片只能是 JPG 或 PNG 格式!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
        return false
      }
      return true
    },
    // 视频上传前校验
    beforeVideoUpload (file) {
      const isVideo = file.type === 'video/mp4' || file.type === 'video/avi'
      const isLt50M = file.size / 1024 / 1024 < 50

      if (!isVideo) {
        this.$message.error('上传视频只能是 MP4 或 AVI 格式!')
        return false
      }
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 50MB!')
        return false
      }
      return true
    },
    // 新增-列表封面上传
    handleAddIconUpload (options) {
      this.handleFileUpload(options, 'add', 'actionIcon', 'images/action/')
    },
    // 新增-详情页封面上传
    handleAddIconDetailsUpload (options) {
      this.handleFileUpload(options, 'add', 'actionIconDetails', 'images/action/')
    },
    // 新增-视频上传
    handleAddVideoUpload (options) {
      this.handleFileUpload(options, 'add', 'actionVideoUrl', 'video/')
    },
    // 编辑-列表封面上传
    handleEditIconUpload (options) {
      this.handleFileUpload(options, 'edit', 'actionIcon', 'images/action/')
    },
    // 编辑-详情页封面上传
    handleEditIconDetailsUpload (options) {
      this.handleFileUpload(options, 'edit', 'actionIconDetails', 'images/action/')
    },
    // 编辑-视频上传
    handleEditVideoUpload (options) {
      this.handleFileUpload(options, 'edit', 'actionVideoUrl', 'video/')
    },
    // 通用文件上传处理
    handleFileUpload (options, type, field, category) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 显示 loading
      that.uploadLoading = true
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', category)
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        that.uploadLoading = false
        if (response.data.code === 1) {
          // 使用返回的absoluteUrl，无需手动拼接URL
          const targetData = type === 'add' ? that.addData : that.editData
          const uiField = field + 'Ui'
          // 同时更新原字段和Ui字段
          targetData[field] = response.data.data.relativeUrl
          targetData[uiField] = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        that.uploadLoading = false
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    // 图片URL处理
    getImageUrl (url) {
      if (!url) return ''
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url
    },
    // 视频预览
    previewVideo (url) {
      const fullUrl = this.getImageUrl(url)
      window.open(fullUrl, '_blank')
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      this.dialogI18n = true
    },
    // 批量新增 - 打开弹窗
    clickBatchAdd () {
      this.dialogBatchAdd = true
      // 默认添加一行
      if (this.batchData.length === 0) {
        this.addBatchRow()
      }
    },
    // 批量新增 - 添加一行
    addBatchRow () {
      this.batchData.push({
        calculateType: '1',
        kaluli: '0',
        gangling: '非杠铃',
        actionType: [],
        bodyType: [],
        actionName: '',
        actionIcon: '',
        actionIconUi: '',
        actionIconDetails: '',
        actionIconDetailsUi: '',
        actionTime: '',
        actionVideoUrl: '',
        actionVideoUrlUi: '',
        actionExecutionPoint: '',
        actionRespiratoryRate: '',
        actionSense: '',
        actionErrorCorrection: '',
        actionMuscleRoup: [],
        actionAccessories: [],
        actionLineBegin: []
      })
    },
    // 批量新增 - 删除一行
    deleteBatchRow (index) {
      this.$confirm('确定删除该行数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchData.splice(index, 1)
        this.$message.success('删除成功')
      }).catch(() => {})
    },
    // 批量新增 - 清空
    clearBatchData () {
      this.$confirm('确定清空所有数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.batchData = []
        this.$message.success('清空成功')
      }).catch(() => {})
    },
    // 批量新增 - 图片上传
    handleBatchIconUpload (options, index, field) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'images/action/')
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          const uiField = field + 'Ui'
          // 同时更新原字段和Ui字段
          that.batchData[index][field] = response.data.data.relativeUrl
          that.batchData[index][uiField] = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    // 批量新增 - 视频上传
    handleBatchVideoUpload (options, index) {
      var that = this
      var formData = new FormData()
      var data = Vue.prototype.FunGetBaseSignData()
      
      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data)
      
      // 签名后再添加type参数（type不参与签名计算）
      data.type = 'ajax'
      
      // 添加文件
      formData.append('file', options.file)
      
      // 添加其他参数
      formData.append('tempUuid', data.tempUuid)
      formData.append('timestamp', data.timestamp)
      formData.append('type', data.type)
      formData.append('sign', data.sign)
      formData.append('category', 'video/')
      
      // 使用axios手动上传
      axios.post(that.uploadAction, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(function (response) {
        if (response.data.code === 1) {
          // 同时更新原字段和Ui字段
          that.batchData[index].actionVideoUrl = response.data.data.relativeUrl
          that.batchData[index].actionVideoUrlUi = response.data.data.absoluteUrl
          that.$message.success('上传成功')
          options.onSuccess(response.data)
        } else {
          that.$message.error('上传失败：' + response.data.message)
          options.onError(response.data)
        }
      }).catch(function (error) {
        console.log(error)
        that.$message.error('上传失败！')
        options.onError(error)
      })
    },
    // 批量新增 - 保存数据
    saveBatchData () {
      var that = this
      
      if (that.batchData.length === 0) {
        that.$message.warning('请至少添加一行数据')
        return
      }
      
      // 验证必填字段
      for (let i = 0; i < that.batchData.length; i++) {
        const row = that.batchData[i]
        const rowNum = i + 1
        
        // 动作分类
        if (!row.actionType || row.actionType.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择动作分类`)
          return
        }
        
        // 部位分类
        if (!row.bodyType || row.bodyType.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择部位分类`)
          return
        }
        
        // 计算类型
        if (!row.calculateType) {
          that.$message.error(`第 ${rowNum} 行：请选择计算类型`)
          return
        }
        
        // 动作名称
        if (!row.actionName || row.actionName.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：动作名称不能为空`)
          return
        }
        
        // 列表封面
        if (!row.actionIcon || row.actionIcon.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传列表封面`)
          return
        }
        
        // 详情页封面
        if (!row.actionIconDetails || row.actionIconDetails.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传详情页封面`)
          return
        }
        
        // 动作时长
        if (!row.actionTime || row.actionTime === '' || row.actionTime <= 0) {
          that.$message.error(`第 ${rowNum} 行：请输入有效的动作时长`)
          return
        }
        
        // 动作视频
        if (!row.actionVideoUrl || row.actionVideoUrl.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请上传动作视频`)
          return
        }
        
        // 动作要领
        if (!row.actionExecutionPoint || row.actionExecutionPoint.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入动作要领`)
          return
        }
        
        // 呼吸方法
        if (!row.actionRespiratoryRate || row.actionRespiratoryRate.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入呼吸方法`)
          return
        }
        
        // 动作感觉
        if (!row.actionSense || row.actionSense.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入动作感觉`)
          return
        }
        
        // 易犯错误
        if (!row.actionErrorCorrection || row.actionErrorCorrection.trim() === '') {
          that.$message.error(`第 ${rowNum} 行：请输入易犯错误`)
          return
        }
        
        // 训练肌群
        if (!row.actionMuscleRoup || row.actionMuscleRoup.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择训练肌群`)
          return
        }
        
        // 所需配件
        if (!row.actionAccessories || row.actionAccessories.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择所需配件`)
          return
        }
        
        // 使用位置
        if (!row.actionLineBegin || row.actionLineBegin.length === 0) {
          that.$message.error(`第 ${rowNum} 行：请选择使用位置`)
          return
        }
      }
      
      // 构建请求数据
      const actionList = that.batchData.map(row => {
        return {
          actionType: Vue.prototype.ConvertArrayToString(row.actionType),
          bodyType: Vue.prototype.ConvertArrayToString(row.bodyType),
          actionName: row.actionName,
          actionIcon: row.actionIcon,
          actionIconDetails: row.actionIconDetails,
          actionTime: parseInt(row.actionTime) || 0,
          actionVideoUrl: row.actionVideoUrl,
          actionExecutionPoint: row.actionExecutionPoint,
          actionRespiratoryRate: row.actionRespiratoryRate,
          actionSense: row.actionSense,
          actionErrorCorrection: row.actionErrorCorrection,
          actionMuscleRoup: Vue.prototype.ConvertArrayToString(row.actionMuscleRoup),
          actionAccessories: Vue.prototype.ConvertArrayToString(row.actionAccessories),
          actionLineBegin: Vue.prototype.ConvertArrayToString(row.actionLineBegin),
          calculateType: parseInt(row.calculateType),
          kaluli: row.kaluli || '0',
          gangling: row.gangling || '非杠铃'
        }
      })
      
      console.log('batchData长度:', that.batchData.length)
      console.log('actionList长度:', actionList.length)
      console.log('actionList第一条数据:', actionList[0])
      
      // 构建请求数据（无需签名）
      var data = {
        tempUuid: localStorage.getItem('tempUuid'),
        actionList: actionList
      }
      
      that.batchLoading = true
      
      // 构建请求体
      const requestBody = {
        tempUuid: data.tempUuid,
        actionList: data.actionList
      }
      
      // 打印请求数据用于调试
      console.log('=== 批量新增请求信息 ===');
      console.log('tempUuid:', requestBody.tempUuid);
      console.log('actionList长度:', actionList.length);
      console.log('完整请求体:', JSON.stringify(requestBody, null, 2));
      
      // 使用 JSON 格式发送
      axios.post(Vue.prototype.global.Url_Base + 'ActionDatabase/batchInsert', requestBody, {
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function (response) {
        that.batchLoading = false
        if (response.data.code === 1) {
          that.$message.success('批量新增成功！共 ' + that.batchData.length + ' 条数据')
          that.batchData = []
          that.dialogBatchAdd = false
          // 刷新列表
          that.ActionDatabaseList()
          that.ActionDatabaseNum()
        } else {
          that.$message.error('批量新增失败：' + response.data.msg)
        }
      }).catch(function (error) {
        that.batchLoading = false
        console.log(error)
        that.$message.error('批量新增失败！')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-top: 15px;

  .search-content {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
  }

  .el-input {
    width: 150px;
  }

  .el-select{
    width: 150px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;

    .search-content {
      gap: 10px;
    }

    .el-input {
      width: 120px;
    }

    .el-select{
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

// 表格横向滚动容器
.table-container {
  width: 100%;
  overflow-x: auto;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

// 上传组件样式
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409EFF;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

.video-uploader {
  /deep/ .el-upload {
    display: inline-block;
  }
}

// 批量新增样式
.batch-dialog {
  /deep/ .el-dialog__header {
    padding: 15px 20px;
    background: #f6f6fa;
  }
  
  /deep/ .el-dialog__body {
    padding: 0;
    height: calc(100vh - 130px);
  }
  
  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    text-align: center;
    border-top: 1px solid #f2f2f2;
  }
}

.batch-add-container {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.batch-toolbar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  
  .batch-tip {
    color: #909399;
    font-size: 14px;
    margin-left: 20px;
  }
}

.batch-table {
  flex: 1;
  
  /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }
  
  /deep/ .el-input__inner {
    padding: 5px 10px;
  }
  
  /deep/ .el-textarea__inner {
    padding: 5px 10px;
    min-height: 50px !important;
  }
  
  /deep/ .el-select {
    width: 100%;
  }
}

// 批量上传组件样式
.batch-uploader {
  /deep/ .el-upload {
    display: block;
    text-align: center;
  }
}

.batch-preview-image {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 auto;
}

// 必填字段标记
.required-field {
  &::before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
